/**
 * Custom fonts available in the BEE Plugin editor
 *
 * Includes both web fonts (loaded via Google Fonts) and web-safe fonts
 * that are likely to be available on most systems.
 */
export const CUSTOM_FONTS = [
  // Modern Web Fonts
  {
    name: "Poppins",
    fontFamily: "'Poppins', Arial, sans-serif",
    url: "https://fonts.googleapis.com/css?family=Poppins"
  },
  {
    name: "Merriweather",
    fontFamily: "'Merriweather', Georgia, 'Times New Roman', serif",
    url: "https://fonts.googleapis.com/css?family=Merriweather"
  },
  {
    name: "Playfair Display",
    fontFamily: "'Playfair Display', Georgia, 'Times New Roman', serif",
    url: "https://fonts.googleapis.com/css?family=Playfair+Display"
  },

  // Additional Web-Safe Fonts
  {
    name: "Calibri",
    fontFamily: "Calibri, 'Trebuchet MS', Arial, sans-serif"
  },
  {
    name: "Century Gothic",
    fontFamily: "'Century Gothic', CenturyGothic, AppleGothic, sans-serif"
  },
  {
    name: "Franklin Gothic",
    fontFamily:
      "'Franklin Gothic Medium', 'Franklin Gothic', 'ITC Franklin Gothic', Arial, sans-serif"
  },
  {
    name: "Garamond",
    fontFamily:
      "Garamond, Baskerville, 'Baskerville Old Face', 'Hoefler Text', 'Times New Roman', serif"
  },
  {
    name: "Cambria",
    fontFamily: "Cambria, Georgia, serif"
  },
  {
    name: "Copperplate",
    fontFamily: "Copperplate, 'Copperplate Gothic Light', fantasy"
  }
];
